import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import logo from '../assets/logo.png';
import { PATH } from '../routes/Routes';
import { Image, Row, Col, } from 'antd';
import Title from 'antd/es/typography/Title';
import { ArrowLeftOutlined } from '@ant-design/icons';
import ColorButton from '../components/common/ColorButton';
import { GREEN } from '../constance/color';


export default function NotFoundView() {

  const history = useHistory();
  const { t } = useTranslation();

  return (
    <div className='not-found'>
      <style>
        {`
          body > div,
          body > div > div,
          body > div > div > div.not-found {
            height: 100%;
          }
        `}
      </style>

      <Row style={{ height: '100%', textAlign: 'center', verticalAlign: 'middle' }}>
        <Col sm={24} md={24} lg={24} style={{ textAlign: 'center', }}>
          <Image src={logo} width='small' />
          <Title type="success" style={{ fontSize: '5rem' }}>404</Title>
          <Title level={3} type="secondary">{t('error_messages.page_not_found')}</Title>
          <ColorButton
            type='primary'
            override={GREEN}
            size='large'
            icon={<ArrowLeftOutlined />}
            onClick={() => history.push(PATH.HOME)} >{t('back')}</ColorButton>
        </Col>
      </Row>

    </div>
  )
}